import * as types from '@/store/types';

export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        [types.APP_START]: (context) => {
            context.dispatch(types.APPROVE_START_TIMER_UNAPPROVED_COUNT);
        },
    },
};
